import React from "react";

const LoadingSpinner = ({ text = "Loading...", theme = "dark" }) => {
  const isDark = theme === "dark";
  
  return (
    <div
      style={{
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        gap: 12,
        background: isDark ? "rgba(255,255,255,0.12)" : "rgba(255,255,255,1)",
        backdropFilter: isDark ? "blur(8px)" : "none",
        border: isDark ? "1px solid rgba(255,255,255,0.18)" : "1px solid rgba(0,0,0,0.05)",
        boxShadow: isDark ? "none" : "0 2px 8px rgba(0,0,0,0.05)",
        borderRadius: "999px",
        padding: "10px 20px",
      }}
    >
      <div
        style={{
          width: 16,
          height: 16,
          flexShrink: 0,
          border: `2px solid ${isDark ? "rgba(255,255,255,0.3)" : "rgba(0,0,0,0.1)"}`,
          borderTopColor: "#d34a9a",
          borderRadius: "50%",
          animation: "nw-spin 0.8s linear infinite",
        }}
      />
      <span
        style={{
          color: isDark ? "rgba(255,255,255,0.85)" : "rgba(0,0,0,0.6)",
          fontSize: "13px",
          fontWeight: 500,
          letterSpacing: "0.03em",
          whiteSpace: "nowrap",
        }}
      >
        {text}
      </span>
    </div>
  );
};

export default LoadingSpinner;
